/* SOLARA desktop navigation: hover-intent + click + keyboard. */
(function () {
  function init(root) {
    if (!root || root.__snav) return;
    root.__snav = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-snav-item]'));
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var current = null, openT = null, closeT = null;

    function parts(item) {
      return { btn: item.querySelector('[data-snav-trigger]'), panel: item.querySelector('[data-snav-panel]') };
    }
    function open(item) {
      clearTimeout(closeT);
      if (current === item) return;
      if (current) close(current, true);
      var p = parts(item);
      current = item;
      item.classList.add('is-open');
      p.btn.setAttribute('aria-expanded', 'true');
      p.panel.hidden = false;
      requestAnimationFrame(function () { p.panel.classList.add('is-visible'); });
    }
    function close(item, instant) {
      if (!item) return;
      var p = parts(item);
      item.classList.remove('is-open');
      p.btn.setAttribute('aria-expanded', 'false');
      p.panel.classList.remove('is-visible');
      if (instant) { p.panel.hidden = true; }
      else { setTimeout(function () { if (!item.classList.contains('is-open')) p.panel.hidden = true; }, 200); }
      if (current === item) current = null;
    }

    items.forEach(function (item) {
      var p = parts(item);
      p.btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) { close(item); } else { open(item); }
      });
      if (hoverable) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeT); clearTimeout(openT);
          openT = setTimeout(function () { open(item); }, current ? 0 : 120);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(openT);
          closeT = setTimeout(function () { close(item); }, 220);
        });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          close(item, true); p.btn.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (current && !current.contains(e.target)) close(current);
    });
    window.addEventListener('resize', function () { if (current) close(current, true); });
  }

  function boot() { document.querySelectorAll('[data-snav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
